import type { CSSProperties } from "react";

/** One of the eight pairs, by a hash of the name: the same person is always the same colour. */
export function avatarSlot(name: string): number {
  let hash = 0;
  for (const char of name) {
    hash = (hash * 31 + (char.codePointAt(0) ?? 0)) >>> 0;
  }
  return (hash % 8) + 1;
}

export function avatarStyle(name: string): CSSProperties {
  const slot = String(avatarSlot(name));
  return { background: `var(--k-avatar-${slot}-bg)`, color: `var(--k-avatar-${slot}-ink)` };
}
